import { render } from "./LoaderView.vue?vue&type=template&id=c3772544&scoped=true"
import script from "./LoaderView.vue?vue&type=script&lang=js"
export * from "./LoaderView.vue?vue&type=script&lang=js"

import "./LoaderView.vue?vue&type=style&index=0&id=c3772544&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3772544"]])

export default __exports__